import api from './api';

export async function fetchFavoriteCategories() {
  const response = await api.get('/exam-courses/get-fav-categories');
  return response?.data?.dataset?.data || {};
}

export async function fetchExamCategories() {
  const response = await api.get('/exam-courses/get-exam-categories');
  return response?.data?.dataset?.data || {};
}

export async function fetchMasterExamCategories({ stateId, favouriteStateId, favouriteExamId } = {}) {
  const response = await api.get('/exam-courses/get-exam-categories', {
    params: {
      state_id: Number(stateId) || undefined,
      favourite_state_id: Number(favouriteStateId) || undefined,
      favourite_exam_id: Number(favouriteExamId) || undefined,
    },
  });

  if (response?.data?.error || Number(response?.data?.code) >= 400) {
    throw new Error(response?.data?.message || 'Unable to load exam categories.');
  }

  return response?.data?.dataset?.data || {};
}

export async function setUserExamCategory(payload) {
  const response = await api.post('/set-user-exam-category', payload);
  if (response?.data?.error || Number(response?.data?.code) >= 400) {
    throw new Error(response?.data?.message || 'Unable to select exam category.');
  }
  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchExamsByCategory(params) {
  const response = await api.get('/exam-courses/get-exam-by-category', {
    params,
  });

  if (response?.data?.error || Number(response?.data?.code) >= 400) {
    throw new Error(response?.data?.message || 'Unable to load exams.');
  }

  return {
    payload: response?.data?.dataset?.data || {},
    meta: response?.data || {},
  };
}

export async function fetchExamOverview(examsId) {
  const response = await api.get('/exam-courses/exam-overview', {
    params: { exams_id: examsId },
  });

  return response?.data?.dataset?.data || {};
}

export async function fetchExamCourseCategories(examsId) {
  const response = await api.get('/exam-courses/exam-categories', {
    params: { exams_id: examsId },
  });

  return response?.data?.dataset?.data || {};
}

export async function fetchExamsByMasterExam(masterExamId) {
  const response = await api.get('/exam-courses/get-exams-by-master-exam', {
    params: { md_exam_id: masterExamId },
  });

  return response?.data?.dataset?.data || {};
}

export async function fetchExamReviews(examsId) {
  const response = await api.get('/exam-courses/get-exam-reviews', {
    params: { exams_id: examsId },
  });

  return response?.data?.dataset?.data || {};
}

export async function postExamReview(payload) {
  const response = await api.post('/exam-courses/post-review', payload);
  return response?.data?.dataset?.data || {};
}

export async function fetchExamSubjects(params = {}) {
  const response = await api.get('/exam-courses/exam-subjects', { params });
  return response?.data?.dataset?.data || {};
}

export async function fetchExamSubjectCategories(params = {}) {
  const response = await api.get('/exam-courses/subject-categories', { params });
  return response?.data?.dataset?.data || {};
}

export async function setDefaultExamSubjectCategory(payload = {}) {
  const response = await api.post('/exam-courses/subject-categories/default', payload);
  return response?.data?.dataset?.data || {};
}

export async function fetchExamQuiz(params = {}) {
  const response = await api.get('/exam-courses/exam-quiz', { params });
  return response?.data?.dataset?.data || {};
}

export async function fetchExamPyp(params = {}) {
  const response = await api.get('/exam-courses/exam-pyp', { params });
  return response?.data?.dataset?.data || {};
}

export async function fetchExamTestSeries(params = {}) {
  const response = await api.get('/exam-courses/exam-test-series', { params });
  return response?.data?.dataset?.data || {};
}

export async function fetchExamStates(examsId) {
  const response = await api.get('/exam-courses/get-exam-states', {
    params: { exams_id: examsId },
  });
  return response?.data?.dataset?.data || {};
}

export async function submitExamQuery(payload) {
  const response = await api.post('/exam-courses/exam-queries', payload);
  return response?.data?.dataset?.data || {};
}

export async function updateExamFavourite(payload) {
  const response = await api.post('/add-exam-favourite', payload);
  if (response?.data?.error || Number(response?.data?.code) >= 400) {
    throw new Error(response?.data?.message || 'Unable to update favorite exam.');
  }
  return response?.data?.dataset?.data || {};
}

export async function updateExamTopicToggle(payload) {
  const response = await api.post('/topic-subtopic-toggle-status', payload);
  return response?.data?.dataset?.data || {};
}

export async function generateExamOrder(payload) {
  const response = await api.post('/subscription/generate-order', payload);
  return response?.data?.dataset?.data || {};
}

export async function fetchPaymentGateways(params = {}) {
  const response = await api.get('/payment/get-payment-gateway', { params });
  return response?.data?.dataset?.data || {};
}
